import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Application } from 'app/shared/services/app/application/application.model';
import { ApplicationService } from 'app/shared/services/app/application/application.service';
import { RoleType } from 'app/shared/services/user/user-application-properties.model';
import { Session } from 'app/shared/services/session/session.service';
import { LoaderButton } from 'app/shared/components/loader-button/loader-button.component';
import { ActiveUser } from '../../services/user/active-user.model';

@Component({
  selector: 'tog-top-nav',
  templateUrl: 'top-nav.template.html',
  styleUrls: ['top-nav.scss']
})
export class TopNavComponent implements OnInit, OnDestroy {
  user: ActiveUser;
  brand: string = 'Interapt';
  subscriptions: any[] = [];
  arrowLeftOffset: number = 0;
  userInfo: any;
  app: any;
  offsetLeft: number = 0;

  @ViewChild('confirmLogoutButton') confirmLogoutButton: LoaderButton;

  constructor(private _session: Session,
              private _router: Router,
              private _as: ApplicationService,
              private _el: ElementRef) {
    // Watch for URL changes to update the header text
    this.subscriptions.push(this._router.events.subscribe((e: any) => {
      if (e.url) {
        let splitUrl = e.url.split('/');
        if (splitUrl[1] === 'app') {
          this._session.user().then(() => {
            return this._as.getApplicationDetails(splitUrl[2]);
          })
          .then((app: Application) => {
            this.app = app;
            this.brand = app.fullName;
          })
          .catch(() => {});
        } else if (e instanceof NavigationEnd) {
          this.brand = 'Interapt';
          this.app = null;
        }
      }
    }));
  }

  ngOnInit() {
    this._session.user().then((user: ActiveUser) => {
      this.user = user;
      setTimeout(() => {
        this.userInfo = this._el.nativeElement.getElementsByClassName('user-info')[0];
        this.userInfo.getBoundingClientRect();
        this.findArrowOffsets();
      });
    })
    .catch((e) => {
      console.log(e);
    });
  }

  findArrowOffsets() {
    if (this.userInfo && this.userInfo.getBoundingClientRect().width > 0) {
      let chevron = this._el.nativeElement.getElementsByClassName('oi oi-chevron-bottom')[0].getBoundingClientRect();
      let user = this._el.nativeElement.getElementsByClassName('user')[0].getBoundingClientRect();
      setTimeout(() => {
        this.arrowLeftOffset = chevron.left - user.left - (user.width / 2) + 3;
        if (this.arrowLeftOffset < -100) {
          this.offsetLeft = this.arrowLeftOffset + 40;
          this.arrowLeftOffset = -85;
        } else {
          this.offsetLeft = 0;
        }
      }, 0);

    }
  }

  goToDashboard() {
   this._router.navigate(['/apps']);
  }

  goToAccountSettings() {
    this._router.navigate(['/account_settings']);
  }

  logout() {
    this._session.logout();
    this.confirmLogoutButton.setConfirmed();
    this._router.navigate(['/login']);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/top-nav/top-nav.component.ts